export enum IdentityValidationCanceledStatus {
  CANCELED = 'canceled',
  CANCELED_BY_MERCHANT = 'canceled_by_merchant',
  CANCELED_BY_DLOCAL = 'canceled_by_dlocal',
}
